var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChedraui(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 4157 2552",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695.119,737.923L742.199,668.992L765.957,668.992L812.165,737.923L822.845,737.923L768.791,661.14L739.801,661.14L686.181,737.923L695.119,737.923Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.081,713.548C837.081,726.636 847.106,737.98 860.402,737.98L930.804,737.98C943.228,737.98 954.78,729.254 954.78,716.384L954.78,661.195L944.754,661.195L944.754,715.948C944.754,723.148 939.523,729.472 932.113,729.472L860.402,729.472C852.773,729.472 846.888,722.929 846.888,715.293L846.888,661.195L837.081,661.195L837.081,713.548Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.56,714.037C673.56,707.495 671.599,705.531 670.072,704.877L668.547,704.222L670.509,702.914C673.996,700.513 673.56,694.625 673.56,693.971L673.56,681.534C673.56,670.41 664.405,661.25 653.291,661.25L557.604,661.25L557.604,737.814L567.413,737.596L567.413,669.32L650.892,669.32C657.866,669.32 663.969,674.773 663.969,681.97L663.969,694.408C663.969,697.896 662.226,702.259 660.263,703.349L658.739,704.222L660.046,705.313C662.008,707.058 663.535,709.021 663.535,714.037L663.535,737.596L673.56,737.596L673.56,714.037Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.504,661.211L417.722,737.776L508.83,737.776C520.381,737.776 531.716,729.922 531.716,717.707L531.716,681.277C531.716,668.844 520.163,661.211 508.393,661.211L417.504,661.211Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.705,737.91L391.705,729.619L287.519,729.619L287.519,669.415L391.705,669.415L391.705,661.343L278.801,661.343L278.801,737.91L391.705,737.91Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.276,716.279C12.494,712.353 12.276,681.593 12.276,680.939C12.931,673.961 15.108,669.162 25.572,669.162L115.374,669.162L115.374,661.091L25.79,661.091C14.237,661.091 3.338,669.162 3.338,681.158L3.338,716.279C3.338,728.06 13.147,737.656 24.919,737.656L115.374,737.656L115.374,729.584L24.919,729.584C17.506,729.366 12.276,723.259 12.276,716.279Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M796.69,737.923L807.588,737.923L792.765,716.982L714.517,716.982L700.132,737.706L711.467,737.706L718.877,725.054L787.97,725.054L796.69,737.923Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.455,697.153L391.846,697.153L391.846,687.99L300.956,687.99L300.956,681.663L391.846,681.663L391.846,673.811L292.455,673.811L292.455,697.153Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.019,701.951L292.019,724.855L391.846,725.074L391.846,716.566L300.956,716.784L300.956,709.587L391.846,709.587L391.846,701.951L292.019,701.951Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.289,716.06C17.506,720.642 20.34,725.005 24.7,725.222L115.374,725.222L115.374,716.714L25.135,716.714L25.135,681.593L115.374,681.593L115.374,673.742L24.919,673.742C20.123,673.742 17.289,676.578 17.289,681.593L17.289,716.06Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.382,669.358C515.356,669.358 522.332,673.937 522.332,681.355L522.332,716.476C522.332,724.109 515.793,729.782 508.382,729.782L426.647,729.782L426.647,669.358L508.382,669.358Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.804,716.82L859.749,716.82L859.749,661.195L851.248,661.195L851.248,716.166C851.248,720.965 854.734,725.329 859.749,725.329L930.804,725.329C935.818,725.329 940.177,721.402 940.177,716.384L940.177,661.195L930.804,661.195L930.804,716.82Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.429,737.741L581.456,737.741L581.456,714.181L649.677,714.181L649.677,737.959L659.923,737.959L659.923,713.963C659.923,708.511 654.908,706.112 649.677,706.112L571.429,706.112L571.429,737.741Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M650.023,702.539C655.037,702.539 659.834,699.266 659.834,694.032L659.834,683.56C659.834,678.326 655.692,673.963 650.46,673.963L571.558,673.963L571.558,702.539L650.023,702.539Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.778,673.937L431.183,673.937L431.183,725.419L508.56,725.419C513.356,725.419 517.932,721.929 517.932,716.913L517.932,681.355C517.932,676.554 513.138,673.937 508.778,673.937Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.657,697.457L240.535,697.457L240.535,661.246L232.252,661.464L232.252,687.859L162.94,687.859L162.94,661.464L154.657,661.464L154.657,697.457Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.657,701.82L154.657,738.029L162.94,738.029L162.94,709.455L232.252,709.455L232.252,738.248L240.535,738.029L240.535,701.82L154.657,701.82Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.213,673.792L744.379,673.792L718.222,711.966L789.715,711.966L764.213,673.792Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.619,
    y: 681.712,
    width: 67.786,
    height: 35.121,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.503,681.679L649.943,681.679L649.726,694.552L581.503,694.552L581.503,681.679Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.924,702.527L735.129,702.527L747.987,681.365L760.412,681.365L773.924,702.527Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2458.35,1434.87L2912.99,1957.49L2635.86,1959.51L2224.03,1484.57L1826.6,1959.51L1542.57,1959.51L1982.81,1434.87L2458.35,1434.87ZM849.638,1591.1L1133.05,1591.1L817.988,1958.1L539.846,1958.1L849.638,1591.1ZM1862.95,1250.75L1269.54,1957.99L912.472,1957.99L1499.8,1250.75L1862.95,1250.75ZM3533.46,1764.34C3491.68,1764.34 3457.6,1798.42 3457.6,1840.22C3457.6,1882.01 3491.68,1916.09 3533.46,1916.09C3575.26,1916.09 3609.34,1882.01 3609.34,1840.22C3609.34,1798.42 3575.26,1764.34 3533.46,1764.34ZM3228.4,1764.34C3186.61,1764.34 3152.53,1798.42 3152.53,1840.22C3152.53,1882.01 3186.61,1916.09 3228.4,1916.09C3270.2,1916.09 3304.28,1882.01 3304.28,1840.22C3304.28,1798.42 3270.2,1764.34 3228.4,1764.34ZM3609.74,1725.87L3129.33,1725.87L2839.42,1143L2947.56,1142.39L3071.31,1375.09L3609.74,1375.5L3609.74,1725.87ZM854.313,1065.47L855.321,1531.49L1177.49,1530.27L1204.07,1497.6L854.313,1065.47ZM849.246,982.346L1231.67,1452.01L1390.52,1270.84L1151.53,981.129L849.246,982.346ZM2110.53,697.545L2110.53,1172.68L1869.31,1378.19L2458.46,1378.19L2461.92,1118.31L2110.53,697.545ZM2747.58,1142.91C2714.31,1142.91 2687.33,1169.89 2687.33,1203.17C2687.33,1236.44 2714.31,1263.42 2747.58,1263.42C2780.85,1263.42 2807.84,1236.44 2807.84,1203.17C2807.84,1169.89 2780.85,1142.91 2747.58,1142.91ZM3167.7,976.096C3090.41,976.096 3027.72,1038.79 3027.72,1116.08C3027.72,1193.38 3090.41,1256.06 3167.7,1256.06C3245,1256.06 3307.69,1193.38 3307.69,1116.08C3307.69,1038.79 3245,976.096 3167.7,976.096ZM1894.01,1192L1530.46,1192L1530.06,543.196L1894.01,986.892L1894.01,1192ZM2110.53,626.817L2415.86,626.817L2800.32,1083.7L2496.6,1083.7L2110.53,626.817ZM1545.18,483.008L1951.74,982.304L2041.42,982.5L2041.42,709.629L1854.16,482.204L1545.18,483.008ZM1028.03,613.345C940.017,613.345 868.372,685 868.372,773.016C868.372,861.029 940.017,932.683 1028.03,932.683C1116.05,932.683 1187.69,861.029 1187.69,773.016C1187.69,685 1116.05,613.345 1028.03,613.345ZM2279.95,219.629C2181.76,219.629 2101.83,299.559 2101.83,397.754C2101.83,495.95 2181.76,575.883 2279.95,575.883C2378.15,575.883 2458.09,495.95 2458.09,397.754C2458.09,299.559 2378.15,219.629 2279.95,219.629ZM1712.05,0C1594.59,0 1499.03,95.559 1499.03,213.029C1499.03,330.495 1594.59,426.05 1712.05,426.05C1829.52,426.05 1925.08,330.495 1925.08,213.029C1925.08,95.559 1829.52,0 1712.05,0Z",
    style: {
      fill: "rgb(246,137,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 991.666,
    y: 661.244,
    width: 9.155,
    height: 76.567,
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M985.998,737.811L985.998,661.026L976.409,661.026L976.627,737.811L985.998,737.811Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.734,738.248L150.734,661.464L142.451,661.464L142.451,738.029L150.734,738.248Z",
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,-13.9079,-524.429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.548,
    y: 661.246,
    width: 7.629,
    height: 76.347,
    style: {
      fill: "rgb(0,70,133)",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChedraui);
export default __webpack_public_path__ + "static/media/Chedraui.2b7ff8dc532377b98fbb00b6393b5bd4.svg";
export { ForwardRef as ReactComponent };